module.exports = __webpack_public_path__ + "img/artwork.42ab2e43.svg";